"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * This plugin is responsible for capturing JavaScript errors from your web
 * application.
 *
 * The following sources of errors are captured:
 *
 * - JavaScript runtime errors captured via the
 *   [`onerror`](https://mzl.la/3bv70O2) global event handler
 *
 * - JavaScript runtime errors captured via the
 *   [`unhandledrejection`](https://mzl.la/2Z26x3l) global event handler
 *
 * The plugins adds the following parameters to the beacon:
 *
 * - `uncaughtErrorCount`: number of uncaught errors that have occured since
 *   navigation start or since the last beacon fired.
 *
 * - `unhandledRejectionCount`: number of unhandled rejections that have occured
 *   since navigation start or since the last beacon fired.
 */
var createErrorsPlugin = function createErrorsPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$monitorGlobal = _ref.monitorGlobal,
      monitorGlobal = _ref$monitorGlobal === void 0 ? true : _ref$monitorGlobal,
      _ref$monitorRejection = _ref.monitorRejections,
      monitorRejections = _ref$monitorRejection === void 0 ? true : _ref$monitorRejection;

  return function (_ref2) {
    var addVariable = _ref2.addVariable;
    var uncaughtErrors = [];
    var unhandledRejections = [];
    var firstBeacon = true;

    var uncaughtErrorHandler = function uncaughtErrorHandler(event) {
      uncaughtErrors.push(event);
    };

    var unhandledRejectionHandler = function unhandledRejectionHandler(event) {
      unhandledRejections.push({
        promise: event.promise,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        reason: event.reason
      });
    };

    var rejectionHandledHandler = function rejectionHandledHandler(event) {
      unhandledRejections = unhandledRejections.filter(function (unhandledRejection) {
        return unhandledRejection.promise !== event.promise;
      });
    };

    if (monitorGlobal) {
      window.addEventListener('error', uncaughtErrorHandler, true);
    }

    if (monitorRejections) {
      window.addEventListener('unhandledrejection', unhandledRejectionHandler, true);
      window.addEventListener('rejectionhandled', rejectionHandledHandler, true);
    }

    return {
      beaconWillSendData: function beaconWillSendData() {
        var uncaughtErrorCount = uncaughtErrors.length;
        var unhandledRejectionCount = unhandledRejections.length;

        if (firstBeacon || uncaughtErrorCount > 0) {
          addVariable('uncaughtErrorCount', uncaughtErrors.length, true);
        }

        if (firstBeacon || unhandledRejectionCount > 0) {
          addVariable('unhandledRejectionCount', unhandledRejections.length, true);
        }

        firstBeacon = false;
        uncaughtErrors = [];
        unhandledRejections = [];
      }
    };
  };
};

var _default = createErrorsPlugin;
exports.default = _default;